import React, { useEffect, useState } from "react";
import { FaRegCopy } from "react-icons/fa6";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const availableNetworks = [
  { name: "Ethereum Mainnet", chainId: 1 },
  { name: "Sepolia testnet", chainId: 11155111 },
  { name: "Polygon", chainId: 137 },
  { name: "Polygon Amoy", chainId: 80002 },
  { name: "BSC", chainId: 56 },
  { name: "BSC testnet", chainId: 97 },
  { name: "Avalanche C-Chain Mainnet", chainId: 43114 },
  { name: "Solana DevNet", chainId: 103 },
  { name: "Solana MainNet", chainId: 101 },
];

const ReceiveModal = ({ isOpen, onClose }) => {
  const [address, setAddress] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const { token } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const fetchAddress = async (chainId) => {
    try {
      let response;
      if (chainId === 103 || chainId === 101) {
        response = await axios.get(`http://159.203.35.6:8080/wallet/getSolanaPKey`, {
          headers: { authorization: `Bearer ${token}` },
        });
      } else {
        response = await axios.get(`http://159.203.35.6:8080/wallet/getPublicKeyEvmGenerated`, {
          headers: { authorization: `Bearer ${token}` },
        });
      }

      if (response?.status === 403) {
        navigate("/connect-wal");
        return;
      }

      setAddress(response?.data?.key);
    } catch (error) {
      if (error?.response?.status === 403) {
        navigate("/connect-wal");
        return;
      }
    }
  };

  const handleSelectChange = (e) => {
    const selectedChainId = parseInt(e.target.value);
    const network = availableNetworks.find((net) => net.chainId === selectedChainId);
    setSelectedNetwork(network);
  };

  useEffect(() => {
    if (selectedNetwork?.chainId) {
      fetchAddress(selectedNetwork.chainId);
    }
  }, [selectedNetwork]);

  if (!isOpen) return null;

  const handleCopy = () => {
    const input = document.createElement("input");
    input.value = address;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);

    const successful = document.execCommand("copy");
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: successful ? "success" : "error",
      title: successful ? "Address copied successfully!" : "Failed to copy address!",
      showConfirmButton: false,
      timer: 2000,
      background: "#be6bed",
      color: "#fff",
    });

    document.body.removeChild(input);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <button className="newnetwork-back-button-select-network" onClick={onClose}>
          &#8592;
        </button>
        <h2 className="modal-title">Account 1</h2>

        <div>
          <h3>Select Network</h3>
          <select
            className="network-selection"
            onChange={handleSelectChange}
            value={selectedNetwork?.chainId || ""}
            style={{ padding: "10px", fontSize: "16px", marginBottom: "20px" }}
          >
            <option value="" disabled>
              Select a Network
            </option>
            {availableNetworks.map((network) => (
              <option key={network.chainId} value={network.chainId}>
                {network.name}
              </option>
            ))}
          </select>
        </div>

        <div className="receive-modal">
          {/* <p>Receive</p> */}
          <p
  style={{
    wordBreak: "break-all",
    padding: "10px 12px",
    borderRadius: "8px",
    backgroundColor: "#fff", // Match modal background (adjust to your modal's actual bg)
    color: "#000", // Optional: ensure contrast
    fontSize: "14px",
    lineHeight: "1.5",
  }}
>
  {address}
</p>

          <p
            onClick={handleCopy}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              color: "#007bff",
              fontWeight: "bold",
            }}
          >
            Copy address <FaRegCopy style={{ marginLeft: "5px" }} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReceiveModal;
